<app-panel [expanded]="true" data-at-installation-card>
  <app-panel-header>{{
    '+INSTALLATIONS.INSTALLATIONS.INSTALLATION_NAME_GENERIC' | translate
  }}</app-panel-header>
  <app-panel-content class="panel-content flex flex-col gap-[8px]">
    <div
      class="flex flex-row gap-[8px] justify-start items-start"
      *ngIf="installationDetailsStore.address$ | async as address"
    >
      <mat-icon>location_on</mat-icon>
      <a
        class="address"
        matTooltip="{{ '+INSTALLATIONS.MAP.VIEW_MAP_TOOLTIP' | translate }}"
        matTooltipPosition="above"
        gtm="onGoToPage"
        gtmAction="Map"
        gtmCategory="deviceCard"
        [routerLink]="['/installations/map']"
        [queryParams]="{
          id: installationId
        }"
      >
        <div class="value" data-at-owner-street>{{ address?.street | dash }}</div>
        <div class="value" data-at-owner-city>{{ address?.city | dash }}</div>
      </a>
    </div>
  </app-panel-content>
</app-panel>
